import { ThunkActionCreator } from "redux";
import { selectPreset } from "~/Redux/preset";
import { SpacesState } from "~/Redux/Spaces";
import { PresetsState } from "../../types";
import { getDefaultPreset } from "../selectors/presets";

export const setDefaultAsCurrent: ThunkActionCreator<PresetsState & SpacesState> = () => (dispatch, getState) => {
    const defaultPreset = getDefaultPreset(getState());
    dispatch(selectPreset({ presetId: defaultPreset.Id }));
};
